export const IS_AUTH_ACTION = "IS_AUTH_ACTION";
export const PERMISSION_ACTION = "PERMISSION_ACTION";
export const REFRESH_SESSION_ACTION = "REFRESH_SESSION_ACTION";
